module.exports = __webpack_public_path__ + "static/media/open-swap-ico.fb10f135.svg";